<app-modal #saveOptionsModal title="Save BATTView Settings" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div class="margin-bottom-sm">Do you want to apply changes immediately?</div>
	<div class="modal-footer padding-8">
		<button class="btn btn-primary" (click)="userSaveOption('direct');saveOptionsModal.hide()">OK</button>
		<button class="btn btn-warning" (click)="userSaveOption();saveOptionsModal.hide()">Queue It</button>
		<button class="btn btn-default" (click)="saveOptionsModal.hide()">Cancel</button>
	</div>
</app-modal>

<app-modal #chargerProfileModal title="Save BATTView Settings" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div class="margin-bottom-sm">Charge profile & EQ, FI scheduling will be updated based on profile selected!</div>
	<div class="modal-footer padding-8">
		<button class="btn btn-primary" (click)="saveBattviewSettings();chargerProfileModal.hide()">OK</button>
		<button class="btn btn-default" (click)="chargerProfileModal.hide()">Cancel</button>
	</div>
</app-modal>

<div *ngIf="isBulk">
	<div class="row" *ngFor="let aBattviewInfo of originalBattviewsInfo; let idx = index" [ngSwitch]="idx % 4">
		<div class="col-xs-3" *ngSwitchCase="0">
			<div class="boxs3 tcenter padding8" *ngIf="originalBattviewsInfo[idx]">
				{{originalBattviewsInfo[idx].batteryid}}<br/>({{originalBattviewsInfo[idx].serialnumber}})
			</div>
		</div>
		<div class="col-xs-3" *ngSwitchCase="0">
			<div class="boxs3 tcenter padding8" *ngIf="originalBattviewsInfo[idx+1]">
				{{originalBattviewsInfo[idx+1].batteryid}}<br/>({{originalBattviewsInfo[idx+1].serialnumber}})
			</div>
		</div>
		<div class="col-xs-3" *ngSwitchCase="0">
			<div class="boxs3 tcenter padding8" *ngIf="originalBattviewsInfo[idx+2]">
				{{originalBattviewsInfo[idx+2].batteryid}}<br/>({{originalBattviewsInfo[idx+2].serialnumber}})
			</div>
		</div>
		<div class="col-xs-3" *ngSwitchCase="0">
			<div class="boxs3 tcenter padding8" *ngIf="originalBattviewsInfo[idx+3]">
				{{originalBattviewsInfo[idx+3].batteryid}}<br/>({{originalBattviewsInfo[idx+3].serialnumber}})
			</div>
		</div>
	</div>
</div>

<div *ngIf="userAccess && hasBattviews">
	<div *ngIf="isSet('CARDS')">
		<div class="cards-flex">
			<div style="background-image: url(./images/Battview_Info.svg);" check-permission="BATTVIEW-INFO" (click)="setTab('BATTVIEW-INFO')" class="cards cards-extra"></div>
			<div style="background-image: url(./images/BattView_WiFi.svg);" check-permission="BATTVIEW-WIFI" (click)="setTab('BATTVIEW-WIFI')" class="cards cards-extra"></div>
			<div style="background-image: url(./images/Battery_Info.svg);" check-permission="BATTVIEW-BATTERY-INFO" (click)="setTab('BATTVIEW-BATTERY-INFO')" class="cards cards-extra"></div>
			<div style="background-image: url(./images/Battview_Settings.svg);" check-permission="BATTVIEW-SETTINGS" (click)="setTab('BATTVIEW-SETTINGS')" class="cards cards-extra"></div>
			<div style="background-image: url(./images/Battview_Cellular.svg);" check-permission="BATTVIEW-CELLULAR" (click)="setTab('BATTVIEW-CELLULAR')" class="cards cards-extra" *ngIf="isBV3"></div>
		</div>
	</div>

	<div check-permission="BATTVIEW-INFO" *ngIf="isSet('BATTVIEW-INFO')">
		<div class="panel panel-default">
			<div class="panel-body">
				<form name="battviewInfo">
					<div class="row">
				 		<div class="panel-body">
							<table class="cellpadding-10 col-xs-5 l">
								<tr check-permission="Batt_SN">
									<td class="col-md-6">Serial Number</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.serialnumber}" [pTooltip]="getStackHTML('serialnumber')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right"><input check-permission="Batt_SN" type="text" class="form-control" name="serialnumber" [(ngModel)]="battview.serialnumber"/>
									</td>
								</tr>
								<tr check-permission="Batt_HWRevision">
									<td class="col-md-6">Hardware Revision</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.hwversion}" [pTooltip]="getStackHTML('hwversion')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right"><input check-permission="Batt_HWRevision" type="text" class="form-control" name="hwversion" [(ngModel)]="battview.hwversion"/></td>
								</tr>
								<tr *ngIf="!isBulk">
									<td class="col-md-6">Firmware Version</td>
									<td><input [disabled]="true" type="text" class="form-control" name="firmwareversion" [(ngModel)]="battview.firmwareversion"/>
									</td>
								</tr>
								<tr check-permission="Batt_memorySignature">
									<td class="col-md-6">Memory Signature</td>
									<td><input check-permission="Batt_memorySignature" type="text" class="form-control" name="memorysignature" [(ngModel)]="battview.memorysignature" />
									</td>
								</tr>
								<tr check-permission="Batt_onlyForEnginneringTeam" *ngIf="battview.esp32_wifi_version >= 1">
									<td class="col-md-6">WiFi FW Version</td>
									<td><input [disabled]="true" type="text" class="form-control" name="esp32_wifi_version" [(ngModel)]="battview.esp32_wifi_version" />
									</td>
								</tr>
								<tr check-permission="Batt_setup_version">
									<td class="col-md-6">Last Change User</td>
									<td><input check-permission="Batt_setup_version" type="text" class="form-control" name="lastchangeuser" [(ngModel)]="battview.lastchangeuser" />
									</td>
								</tr>
								<tr>
									<td class="col-md-6" check-permission="SAVE-BATTVIEW-INFO"><span class="save-btn" (click)="checkChanges('battviewInfo')">Save</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms()">Back</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<div check-permission="BATTVIEW-SETTINGS" *ngIf="isSet('BATTVIEW-SETTINGS')">
		<div class="panel panel-default">
			<div class="panel-body">
				<form name="battviewSettings">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-md-8 l">
								<tr check-permission="Batt_RTSampleTime">
									<td class="col-md-4">Samples Time Span</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.autologtime}" [pTooltip]="getStackHTML('autologtime')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<span class="col-md-12"><input check-permission="Batt_RTSampleTime" type="text" class="form-control" name="autologtime" [(ngModel)]="battview.autologtime"/></span>
									</td>
								</tr>
								<tr check-permission="Batt_setPA">
									<td class="col-md-4">BATTView Mobile</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.ispa}" [pTooltip]="getStackHTML('ispa')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_setPA" type="radio" name="ispa" [(ngModel)]="battview.ispa" class="form-control" [value]="true"/> Yes</label>
										<label><input check-permission="Batt_setPA" type="radio" name="ispa" [(ngModel)]="battview.ispa" class="form-control" [value]="false"/> No</label>
									</td>
								</tr>
								<tr check-permission="Batt_enablePostSensor">
									<td class="col-md-4"><span>Post/Electrolyte NTC</span></td>
									<td [ngClass]="{'dirtySettingsField': changesStack.enableexttempsensing}" [pTooltip]="getStackHTML('enableexttempsensing')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_enablePostSensor" type="radio" name="enableexttempsensing" [(ngModel)]="battview.enableexttempsensing" class="form-control" [value]="true"/> Enable</label>
										<label><input check-permission="Batt_enablePostSensor" type="radio" name="enableexttempsensing" [(ngModel)]="battview.enableexttempsensing" class="form-control" [value]="false"/> Disable</label>
									</td>
								</tr>
								<tr check-permission="Batt_enablePostSensor">
									<td class="col-md-4"><span>External NTC</span></td>
									<td [ngClass]="{'dirtySettingsField': changesStack.disableintercell}" [pTooltip]="getStackHTML('disableintercell')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_enablePostSensor" type="radio" name="disableintercell" [(ngModel)]="battview.disableintercell" class="form-control" [value]="false"/> Enable</label>
										<label><input check-permission="Batt_enablePostSensor" type="radio" name="disableintercell" [(ngModel)]="battview.disableintercell" class="form-control" [value]="true"/> Disable</label>
									</td>
								</tr>
								<tr check-permission="Batt_EnableEL">
									<td class="col-md-4"><span>Electrolyte sensing</span></td>
									<td [ngClass]="{'dirtySettingsField': changesStack.enableelectrolyesensing}" [pTooltip]="getStackHTML('enableelectrolyesensing')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_EnableEL" type="radio" name="enableelectrolyesensing" [(ngModel)]="battview.enableelectrolyesensing" class="form-control" [value]="true"/> Enable</label>
										<label><input check-permission="Batt_EnableEL" type="radio" name="enableelectrolyesensing" [(ngModel)]="battview.enableelectrolyesensing" class="form-control" [value]="false"/> Disable</label>
									</td>
								</tr>
								<tr check-permission="Batt_setHallEffect">
									<td class="col-md-4">Use hall effect sensor</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.enablehalleffectsensing}" [pTooltip]="getStackHTML('enablehalleffectsensing')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_setHallEffect" type="radio" name="enablehalleffectsensing" [(ngModel)]="battview.enablehalleffectsensing" class="form-control" [value]="true"/> Yes</label>
										<label><input check-permission="Batt_setHallEffect" type="radio" name="enablehalleffectsensing" [(ngModel)]="battview.enablehalleffectsensing" class="form-control" [value]="false"/> No</label>
									</td>
								</tr>
								<tr check-permission="Batt_setHallEffect" *ngIf="battview.enablehalleffectsensing">
									<td class="col-md-4">Hall Effect Reverse</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.halleffectreverse}" [pTooltip]="getStackHTML('halleffectreverse')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_setHallEffect" type="radio" name="halleffectreverse" [(ngModel)]="battview.halleffectreverse" class="form-control" [value]="true"/> Yes</label>
										<label><input check-permission="Batt_setHallEffect" type="radio" name="halleffectreverse" [(ngModel)]="battview.halleffectreverse" class="form-control" [value]="false"/> No</label>
									</td>
								</tr>
								<tr check-permission="Batt_enablePLC">
									<td class="col-md-4">Enable PLC</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.enableplc}" [pTooltip]="getStackHTML('enableplc')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_enablePLC" type="radio" name="enableplc" [(ngModel)]="battview.enableplc" class="form-control" [value]="true"/> Enable</label>
										<label><input check-permission="Batt_enablePLC" type="radio" name="enableplc" [(ngModel)]="battview.enableplc" class="form-control" [value]="false"/> Disable</label>
									</td>
								</tr>
								<tr check-permission="Batt_TemperatureFormat">
									<td class="col-md-4">Temperature Format</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.temperatureformat}" [pTooltip]="getStackHTML('temperatureformat')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_TemperatureFormat" type="radio" name="temperatureformat" [(ngModel)]="battview.temperatureformat" class="form-control" [value]="1"/> Fahrenheit</label>
										<label><input check-permission="Batt_TemperatureFormat" type="radio" name="temperatureformat" [(ngModel)]="battview.temperatureformat" class="form-control" [value]="0"/> Celsius</label>
									</td>
								</tr>
								<tr check-permission="Batt_dayLightSaving_Enable">
									<td class="col-md-4">Daylight Saving</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.enabledaylightsaving}" [pTooltip]="getStackHTML('enabledaylightsaving')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_dayLightSaving_Enable" type="radio" name="enabledaylightsaving" [(ngModel)]="battview.enabledaylightsaving" class="form-control" [value]="true"/> Enable</label>
										<label><input check-permission="Batt_dayLightSaving_Enable" type="radio" name="enabledaylightsaving" [(ngModel)]="battview.enabledaylightsaving" class="form-control" [value]="false"/> Disable</label>
									</td>
								</tr>
								<tr check-permission="Batt_numberOfCables" *ngIf="battview.firmwareversion >= 2.2 && battview.enablehalleffectsensing">
									<td class="col-md-4">Number of Cables</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.halleffectscale}" [pTooltip]="getStackHTML('halleffectscale')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-6"><input check-permission="Batt_numberOfCables" type="radio" name="halleffectscale" [(ngModel)]="battview.halleffectscale" class="form-control" [value]="1"/> Single</label>
										<label><input check-permission="Batt_numberOfCables" type="radio" name="halleffectscale" [(ngModel)]="battview.halleffectscale" class="form-control" [value]="2"/> Dual</label>
									</td>
								</tr>
								<tr *ngIf="battview.firmwareversion >= 2.68" check-permission="Batt_onlyForEngineeringTeam">
									<td class="col-md-4">{{'device.plc_gain'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.plc_gain}" [pTooltip]="getStackHTML('plc_gain')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Batt_onlyForEnginneringTeam" [(ngModel)]="battview.plc_gain" name="plc_gain" class="form-control">
											<option *ngFor="let val of devicesDashboard.plcGainVals" [ngValue]="val">{{val}}</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_onlyEngineeringTeam">
									<td class="col-md-4">Temperature Fallback control</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.temperaturecontrol}" [pTooltip]="getStackHTML('temperaturecontrol')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label class="col-md-12" *ngFor="let opt of TemperatureFallbackOpts" >
											<input check-permission="Batt_onlyEngineeringTeam" type="radio" name="temperaturecontrol" [(ngModel)]="battview.temperaturecontrol" class="form-control" [value]="opt.id"/> {{opt.text}}
										</label>
									</td>
								</tr>
								<tr>
									<td class="col-md-4" check-permission="SAVE-BATTVIEW-SETTINGS"><span class="save-btn" (click)="checkChanges('battviewSettings')">Save</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms()">Back</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<div check-permission="BATTVIEW-WIFI" *ngIf="isSet('BATTVIEW-WIFI')">
		<div class="panel panel-default">
			<div class="panel-body">
				<form name="wifi">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-5 l">
								<tr check-permission="Batt_mobileAccessSSID">
									<td class="col-md-6">Mobile SSID</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.mobileaccessssid}" [pTooltip]="getStackHTML('mobileaccessssid')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_mobileAccessSSID" type="text" class="form-control" name="mobileaccessssid" [(ngModel)]="battview.mobileaccessssid"/>
									</td>
								</tr>
								<tr check-permission="Batt_mobileAccessSSIDPassword">
									<td class="col-md-6">Mobile SSID Password</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.mobileaccessssidpassword}" [pTooltip]="getStackHTML('mobileaccessssidpassword')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class="input-group">
											<input check-permission="Batt_mobileAccessSSIDPassword" [type]="mobilePassword ? 'text': 'password'" class="form-control" [(ngModel)]="battview.mobileaccessssidpassword" name="mobileaccessssidpassword"/>
											<span class="input-group-btn"><button class="pswdBtn" check-permission="Batt_mobileAccessSSIDPassword"  (click)="mobilePassword = !mobilePassword" type="button"><i class="pi pi-eye eyeStyle"></i></button></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_mobilePort">
									<td class="col-md-6">Mobile SSID Port</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.mobileport}" [pTooltip]="getStackHTML('mobileport')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_mobilePort" type="text" class="form-control" name="mobileport" [(ngModel)]="battview.mobileport"/>
									</td>
								</tr>
								<tr check-permission="Batt_actViewEnabled">
									<td class="col-md-6">ACT intelligent</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewenabled}" [pTooltip]="getStackHTML('actviewenabled')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label><input check-permission="Batt_actViewEnabled" type="radio" name="actviewenabled" [(ngModel)]="battview.actviewenabled" class="form-control" [value]="true"/> Enable</label>
										<label><input check-permission="Batt_actViewEnabled" type="radio" name="actviewenabled" [(ngModel)]="battview.actviewenabled" class="form-control" [value]="false"/> Disable</label>
									</td>
								</tr>
								<tr check-permission="Batt_actViewIP">
									<td class="col-md-6">ACTView IP</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewip}" [pTooltip]="getStackHTML('actviewip')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_actViewIP" type="text" class="form-control" name="actviewip" [(ngModel)]="battview.actviewip" [disabled]="!battview.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Batt_actViewPort">
									<td class="col-md-6">ACTView Port</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewport}" [pTooltip]="getStackHTML('actviewport')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_actViewPort" type="text" class="form-control" name="actviewport" [(ngModel)]="battview.actviewport" [disabled]="!battview.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Batt_actViewConnectFrequency">
									<td class="col-md-6">ACTView Connect Frequency</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewconnectfrequency}" [pTooltip]="getStackHTML('actviewconnectfrequency')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_actViewConnectFrequency" type="text" class="form-control" name="actviewconnectfrequency" [(ngModel)]="battview.actviewconnectfrequency" [disabled]="!battview.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Batt_actAccessSSID">
									<td class="col-md-6">ACTaccess SSID</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actaccessssid}" [pTooltip]="getStackHTML('actaccessssid')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_actAccessSSID" type="text" class="form-control" name="actaccessssid" [(ngModel)]="battview.actaccessssid" [disabled]="!battview.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Batt_actAccessSSIDpassword">
									<td class="col-md-6">ACTaccess SSID Password</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actaccessssidpassword}" [pTooltip]="getStackHTML('actaccessssidpassword')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class="input-group">
											<input check-permission="Batt_actAccessSSIDpassword" [type]="actAccessPassword ? 'text': 'password'" class="form-control" [(ngModel)]="battview.actaccessssidpassword" name="actaccessssidpassword" [disabled]="!battview.actviewenabled"/>
											<span class="input-group-btn"><button class="pswdBtn" check-permission="Batt_actAccessSSIDpassword"  (click)="actAccessPassword = !actAccessPassword" type="button" [disabled]="!battview.actviewenabled"><i class="pi pi-eye eyeStyle"></i></button></span>
										</div>
									</td>
								</tr>
								<tr *ngIf="currentUser.isACTuser && !isBulk && battview.firmwareversion >= 2.2">
									<td colspan="2">
										<fieldset>
											<legend>WiFi Info</legend>
											<table style="width:100%">
												<tr>
													<td class="col-md-6">AT Version</td>
													<td>
														{{battview.wifi_at_version}}
													</td>
												</tr>
												<tr>
													<td class="col-md-6">Local IP Address</td>
													<td>
														{{battview.wifi_local_ip}}
													</td>
												</tr>
												<tr>
													<td class="col-md-6">Gateway</td>
													<td>
														{{battview.wifi_gateway ? battview.wifi_gateway : 'Unsupported'}}
													</td>
												</tr>
												<tr>
													<td class="col-md-6">MAC Address</td>
													<td>
														{{battview.wifi_mac_address ? commonUtil.getHexMacAddress(battview.wifi_mac_address) : 'Unsupported'}}
													</td>
												</tr>
											</table>
										</fieldset>
									</td>
								</tr>
								<tr>
									<td class="col-md-6" check-permission="SAVE-BATTVIEW-WIFI"><span class="save-btn" (click)="checkChanges('wifi')">Save</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms()">Back</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<div check-permission="BATTVIEW-BATTERY-INFO" *ngIf="isSet('BATTVIEW-BATTERY-INFO')">
		<div check-permission="BATTVIEW-BATTERY-SETTINGS" (click)="setTab('BATTVIEW-BATTERY-SETTINGS')" class="sub-cards boxs3 col-md-4 col-md-offset-4">View Battery Settings</div>
		<div check-permission="BATTVIEW-DEFAULT-CHARGE-PROFILE" (click)="setTab('BATTVIEW-DEFAULT-CHARGE-PROFILE')" class="sub-cards boxs3 col-md-4 col-md-offset-4" *ngIf="!isBattviewMobile">View Default Charge Profile</div>
		<div check-permission="BATTVIEW-FI-EQ-SCHEDULING" (click)="setTab('BATTVIEW-FI-EQ-SCHEDULING')" class="sub-cards boxs3 col-md-4 col-md-offset-4" *ngIf="!isBattviewMobile">View Finish and EQ Scheduling</div>
		<div (click)="setTab('CARDS')" class="back-btn-card boxs3 col-md-4 col-md-offset-4">Back</div>
	</div>

	<div check-permission="BATTVIEW-BATTERY-SETTINGS" *ngIf="isSet('BATTVIEW-BATTERY-SETTINGS')">
		<div class="panel panel-default">
			<div class="panel-body">
				<form name="batterySettings">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-6 l">
								<tr check-permission="Batt_batteryID">
									<td class="col-md-6">Battery ID</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.batteryid}" [pTooltip]="getStackHTML('batteryid')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_batteryID" type="text" class="form-control" name="batteryid" [(ngModel)]="battview.batteryid"/>
									</td>
								</tr>
								<tr check-permission="Batt_batteryModelandSN" *ngIf="!isBulk">
									<td class="col-md-6">Battery Serial Number</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.batterysn}" [pTooltip]="getStackHTML('batterysn')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_batteryModelandSN" type="text" class="form-control" name="batterysn" [(ngModel)]="battview.batterysn"/>
									</td>
								</tr>
								<tr check-permission="Batt_batteryModelandSN" *ngIf="!isBulk">
									<td class="col-md-6"><span *ngIf="!isBattviewMobile">Battery Model</span><span *ngIf="isBattviewMobile">Truck Type</span></td>
									<td [ngClass]="{'dirtySettingsField': changesStack.batterymodel}" [pTooltip]="getStackHTML('batterymodel')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_batteryModelandSN" type="text" class="form-control" name="batterymodel" [(ngModel)]="battview.batterymodel"/>
									</td>
								</tr>
								<tr check-permission="Batt_batteryModelandSN" *ngIf="!isBulk">
									<td class="col-md-6">Truck ID</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.truckid}" [pTooltip]="getStackHTML('truckid')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_batteryModelandSN" type="text" class="form-control" name="truckid" [(ngModel)]="battview.truckid"/>
									</td>
								</tr>
								<tr check-permission="Batt_InstallationDate">
									<td class="col-md-6">Installation Date</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.installationdate}" [pTooltip]="getStackHTML('installationdate')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<div class="input-group">
											<input check-permission="Batt_InstallationDate" class="form-control" placeholder="mm/dd/yyyy" name="installationdate" [(ngModel)]="battview.installationdate" bsDatepicker #installationdate="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
											<span class="input-group-btn">
												<button check-permission="Batt_InstallationDate" class="btn btn-default btn-date" (click)="installationdate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
											</span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_InstallationDate" *ngIf="!isBulk">
									<td rowspan="2" class="col-md-6">Battery Manufacturing Date</td>
									<td class="col-md-6" style="padding-bottom:0px; padding-left: 8px" [ngClass]="{'dirtySettingsField': changesStack.batterymanfacturingdate}" [pTooltip]="getStackHTML('batterymanfacturingdate')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<label>
											<span class="col-md-12">Same as Installation Date:</span>
											<label class="col-md-6"><input check-permission="Batt_InstallationDate" type="radio" (click)="setManufacturingDate()" name="manufacturingdatesameasinstallation" [(ngModel)]="battview.manufacturingdatesameasinstallation" class="form-control" [value]="true"/> Yes</label>
											<label><input check-permission="Batt_InstallationDate" type="radio" (click)="setManufacturingDate()" name="manufacturingdatesameasinstallation" [(ngModel)]="battview.manufacturingdatesameasinstallation" class="form-control" [value]="false"/> No</label>
										</label>
									</td>
								</tr>
								<tr check-permission="Batt_InstallationDate" *ngIf="!isBulk">
									<td style="padding-top:0px">
										<div class="input-group">
											<input check-permission="Batt_InstallationDate" class="form-control" placeholder="mm/dd/yyyy" name="manufacturingdateview" [(ngModel)]="battview.manufacturingdateview" bsDatepicker #manufacturingdateview="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [disabled]="battview.manufacturingdatesameasinstallation"/>
											<span class="input-group-btn">
												<button check-permission="Batt_InstallationDate" [disabled]="battview.manufacturingdatesameasinstallation" class="btn btn-default btn-date" (click)="manufacturingdateview.toggle()" type="button"><i class="fa fa-calendar"></i></button>
											</span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_TimeZone">
									<td class="col-md-6">Time Zone</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.zoneid}" [pTooltip]="getStackHTML('zoneid')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<select check-permission="Batt_TimeZone" id="timezone" class="form-control" name="zoneid" [(ngModel)]="battview.zoneid">
											<option *ngFor="let zone of commonData.TimeZonesMenu" [ngValue]="zone.id">{{zone.display_name}}</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_BatteryCapacity">
									<td class="col-md-6">Battery Capacity</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.ahrcapacity}" [pTooltip]="getStackHTML('ahrcapacity')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class='input-group'>
											<input check-permission="Batt_BatteryCapacity" type="number" class="form-control" name="ahrcapacity" [(ngModel)]="battview.ahrcapacity" (ngModelChange)="updateWarrantedAhr()"/>
											<span class="input-group-addon"><span>AHRs</span></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_BatteryVoltage">
									<td class="col-md-6">Battery Voltage</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.nominalvoltage}" [pTooltip]="getStackHTML('nominalvoltage')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<select check-permission="Batt_BatteryVoltage" name="nominalvoltage" [(ngModel)]="battview.nominalvoltage" class="form-control">
											<option *ngFor="let voltage of batteryVoltages" [ngValue]="voltage">{{voltage}}</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_temperatureCompensation">
									<td class="col-md-6">Temperature Compensation</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.batterytemperaturecompesnation}" [pTooltip]="getStackHTML('batterytemperaturecompesnation')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class='input-group'>
											<input check-permission="Batt_temperatureCompensation" type="text" class="form-control" name="batterytemperaturecompesnation" [(ngModel)]="battview.batterytemperaturecompesnation"/>
											<span class="input-group-addon"><span>mVPC/C</span></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_TempertureHigh">
									<td class="col-md-6">Max Battery Temperature</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.batteryhightemperature}" [pTooltip]="getStackHTML('batteryhightemperature')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class='input-group'>
											<input check-permission="Batt_TempertureHigh" type="text" class="form-control" name="batteryhightemperature" [(ngModel)]="battview.batteryhightemperature"/>
											<span class="input-group-addon"><span>&deg;{{formatTemperature}}</span></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_BatteryType">
									<td class="col-md-6">Battery Type</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.batterytype}" [pTooltip]="getStackHTML('batterytype')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<select check-permission="Batt_BatteryType" name="batterytype" [(ngModel)]="battview.batterytype" class="form-control">
											<option *ngFor="let type of batteryTypes" [ngValue]="type.id">{{type.text}}</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_OverrideWarrantedAHR">
									<td class="col-md-6">Warranted AHR</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.warrantedahr}" [pTooltip]="getStackHTML('warrantedahr')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<input check-permission="Batt_OverrideWarrantedAHR" type="text" class="form-control" name="warrantedahr" [(ngModel)]="battview.warrantedahr"/>
									</td>
								</tr>
								<tr check-permission="Batt_TempertureHigh">
									<td class="col-md-6">Min Cold Charger Temperature</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.trtemperature}" [pTooltip]="getStackHTML('trtemperature')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class='input-group'>
											<input check-permission="Batt_TempertureHigh" type="text" class="form-control" name="trtemperature" [(ngModel)]="battview.trtemperature"/>
											<span class="input-group-addon"><span>&deg;{{formatTemperature}}</span></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_TempertureHigh">
									<td class="col-md-6">Foldback Temperature</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.foldtemperature}" [pTooltip]="getStackHTML('foldtemperature')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class='input-group'>
											<input check-permission="Batt_TempertureHigh" type="text" class="form-control" name="foldtemperature" [(ngModel)]="battview.foldtemperature"/>
											<span class="input-group-addon"><span>&deg;{{formatTemperature}}</span></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_TempertureHigh">
									<td class="col-md-6">Cool Down Temperature</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.cooldowntemperature}" [pTooltip]="getStackHTML('cooldowntemperature')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<div class='input-group'>
											<input check-permission="Batt_TempertureHigh" type="text" class="form-control" name="cooldowntemperature" [(ngModel)]="battview.cooldowntemperature"/>
											<span class="input-group-addon"><span>&deg;{{formatTemperature}}</span></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Batt_chargerType">
									<td class="col-md-6">Application Type</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.chargertype}" [pTooltip]="getStackHTML('chargertype')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
										<select check-permission="Batt_chargerType" name="chargertype" [(ngModel)]="battview.chargertype" class="form-control">
											<option *ngFor="let type of chargerTypes" [ngValue]="type.id">{{type.text}}</option>
										</select>
									</td>
								</tr>
								<tr>
									<td class="col-md-6" check-permission="SAVE-BATTVIEW-BATTERY-SETTINGS"><span class="save-btn" (click)="checkChanges('batterySettings')">Save</span></td>
									<td><span class="back-btn" (click)="setTab('BATTVIEW-BATTERY-INFO'); resetForms()">Back</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<div check-permission="BATTVIEW-DEFAULT-CHARGE-PROFILE" *ngIf="isSet('BATTVIEW-DEFAULT-CHARGE-PROFILE')">
		<div class="panel panel-default">
			<div class="panel-body">
				<form name="defaultChargeProfile">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-5 l">
							<tr check-permission="Batt_TR_CurrentRate">
								<td class="col-md-6">TR Current Rate (%Capacity) - TR Amps</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.tricklecurrentrate}" [pTooltip]="getStackHTML('tricklecurrentrate')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_TR_CurrentRate" name="tricklecurrentrate" [(ngModel)]="battview.tricklecurrentrate" class="form-control">
										<option *ngFor="let trcurrent of TRCurrentRates" [ngValue]="trcurrent">{{trcurrent}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_CC_CurrentRate">
								<td class="col-md-6">CC Current Rate (%Capacity) - CC Amps</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.ccrate}" [pTooltip]="getStackHTML('ccrate')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_CC_CurrentRate" name="ccrate" [(ngModel)]="battview.ccrate" class="form-control">
										<option *ngFor="let cccurrent of CCCurrentRates" [ngValue]="cccurrent">{{cccurrent}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_FI_CurrentRate">
								<td class="col-md-6">FI Current Rate (%Capacity) - FI Amps</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.ficurrentrate}" [pTooltip]="getStackHTML('ficurrentrate')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_FI_CurrentRate" name="ficurrentrate" [(ngModel)]="battview.ficurrentrate" class="form-control">
										<option *ngFor="let ficurrent of FICurrentRates" [ngValue]="ficurrent">{{ficurrent}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_EQ_CurrentRate">
								<td class="col-md-6">EQ Current Rate (%Capacity) - EQ Amps</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.eqcurrentrate}" [pTooltip]="getStackHTML('eqcurrentrate')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_EQ_CurrentRate" name="eqcurrentrate" [(ngModel)]="battview.eqcurrentrate" class="form-control">
										<option *ngFor="let eqcurrent of EQCurrentRates" [ngValue]="eqcurrent">{{eqcurrent}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_TrickleVoltage">
								<td class="col-md-6">TR Target Voltage</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.tricklevoltage}" [pTooltip]="getStackHTML('tricklevoltage')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<input check-permission="Batt_TrickleVoltage" type="text" class="form-control" name="tricklevoltage" [(ngModel)]="battview.tricklevoltage"/>
								</td>
							</tr>
							<tr check-permission="Batt_CVVoltage">
								<td class="col-md-6">CV Target Voltage</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.cvtargetvoltage}" [pTooltip]="getStackHTML('cvtargetvoltage')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<input check-permission="Batt_CVVoltage" type="text" class="form-control" name="cvtargetvoltage" [(ngModel)]="battview.cvtargetvoltage"/>
								</td>
							</tr>
							<tr check-permission="Batt_finishVoltage">
								<td class="col-md-6">FI Target Voltage</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.fitargetvoltage}" [pTooltip]="getStackHTML('fitargetvoltage')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<input check-permission="Batt_finishVoltage" type="text" class="form-control" name="fitargetvoltage" [(ngModel)]="battview.fitargetvoltage"/>
								</td>
							</tr>
							<tr check-permission="Batt_EqualaizeVoltage">
								<td class="col-md-6">EQ Target Voltage</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.eqvoltage}" [pTooltip]="getStackHTML('eqvoltage')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<input check-permission="Batt_EqualaizeVoltage" type="text" class="form-control" name="eqvoltage" [(ngModel)]="battview.eqvoltage"/>
								</td>
							</tr>
							<tr check-permission="Batt_cvFinishCurrent">
								<td class="col-md-6">Partial Charge Stop Current (%Capacity)</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.cvendcurrentrate}" [pTooltip]="getStackHTML('cvendcurrentrate')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_cvFinishCurrent" name="cvendcurrentrate" [(ngModel)]="battview.cvendcurrentrate" class="form-control">
										<option *ngFor="let current of cvFinishCurrents" [ngValue]="current">{{current}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_cvCurrentStep">
								<td class="col-md-6">CV Current Step (%CC)</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.cvcurrentstep}" [pTooltip]="getStackHTML('cvcurrentstep')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_cvCurrentStep" name="cvcurrentstep" [(ngModel)]="battview.cvcurrentstep" class="form-control">
										<option *ngFor="let step of cvCurrentSteps" [ngValue]="step.id">{{step.name}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_CVMaxTimer">
								<td class="col-md-6">CV Timeout</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.cvmaxduration}" [pTooltip]="getStackHTML('cvmaxduration')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_CVMaxTimer" name="cvmaxduration" [(ngModel)]="battview.cvmaxduration" class="form-control">
										<option *ngFor="let period of hours_1_5" [ngValue]="period">{{period}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_finishTimer">
								<td class="col-md-6">Finish Timeout</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.fiduration}" [pTooltip]="getStackHTML('fiduration')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_finishTimer" name="fiduration" [(ngModel)]="battview.fiduration" class="form-control">
										<option *ngFor="let finishtime of quarts_1_6" [ngValue]="finishtime">{{finishtime}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_EqualizeTimer">
								<td class="col-md-6">Equalize Timeout</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.eqduration}" [pTooltip]="getStackHTML('eqduration')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_EqualizeTimer" name="eqduration" [(ngModel)]="battview.eqduration" class="form-control">
										<option *ngFor="let eqtime of quarts_2_6" [value]="eqtime">{{eqtime}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_desulfationTimer">
								<td class="col-md-6">Desulfation Duration</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.desulfation}" [pTooltip]="getStackHTML('desulfation')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<select check-permission="Batt_desulfationTimer" name="desulfation" [(ngModel)]="battview.desulfation" class="form-control">
										<option *ngFor="let hour of quarts_6_18" [value]="hour">{{hour}}</option>
									</select>
								</td>
							</tr>
							<tr check-permission="Batt_finishdVdT">
								<td class="col-md-6">Finish dV Voltage</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.fidv}" [pTooltip]="getStackHTML('fidv')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<div class='input-group'>
										<select check-permission="Batt_finishdVdT" name="fidv" [(ngModel)]="battview.fidv" class="form-control">
											<option *ngFor="let dvvoltage of finishDvVoltages" [ngValue]="dvvoltage">{{dvvoltage}}</option>
										</select>
										<span class="input-group-addon"><span>mVPC</span></span>
									</div>
								</td>
							</tr>
							<tr check-permission="Batt_finishdVdT">
								<td class="col-md-6">Finish dT Time</td>
								<td [ngClass]="{'dirtySettingsField': changesStack.fidt}" [pTooltip]="getStackHTML('fidt')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">
									<div class='input-group'>
										<select check-permission="Batt_finishdVdT" name="fidt" [(ngModel)]="battview.fidt" class="form-control">
											<option *ngFor="let dt of finishDt" [ngValue]="dt">{{dt}}</option>
										</select>
										<span class="input-group-addon"><span>minutes</span></span>
									</div>
								</td>
							</tr>
							<tr>
								<td class="col-md-6" check-permission="SAVE-BATTVIEW-DEFAULT-CHARGE-PROFILE"><span class="save-btn" (click)="checkChanges('defaultChargeProfile')">Save</span></td>
								<td><span class="back-btn" (click)="setTab('BATTVIEW-BATTERY-INFO'); resetForms()">Back</span></td>
							</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<div check-permission="BATTVIEW-FI-EQ-SCHEDULING" *ngIf="isSet('BATTVIEW-FI-EQ-SCHEDULING')">
		<div class="panel panel-default">
			<div class="panel-body">
				<form name="FIEQscheduling">
					<div class="row">
						<div class="panel-body">
							<fieldset check-permission="Batt_FI_sched_Settings" [disabled]="[0, 2].indexOf(battview.chargertype) > -1">
								<legend><span [ngClass]="{'dirtySettingsField': changesStack.fischedulingmode}" [pTooltip]="getStackHTML('fischedulingmode')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">Finish Cycle Settings</span></legend>

								<label><input check-permission="Batt_FI_sched_Settings" type="radio" name="fischedulingmode" [(ngModel)]="battview.fischedulingmode" class="form-control" [value]="0"/> Always</label>
								<label><input check-permission="Batt_FI_sched_Settings" type="radio" name="fischedulingmode" [(ngModel)]="battview.fischedulingmode" class="form-control" [value]="1"/> Custom</label>
							</fieldset>
							<br/>
							<div class="row">
								<div check-permission="Batt_EQ_sched_CustomSettings" class="col-md-4">
									<fieldset>
										<legend>Equalize Cycle</legend>

										<label [ngClass]="{'dirtySettingsField': changesStack.eqstartwindow}" [pTooltip]="getStackHTML('eqstartwindow')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">Window Start Time</label>
										<input type='text' check-permission="Batt_EQ_sched_CustomSettings" name="eqstartwindow" [(ngModel)]="battview.eqstartwindow" class="form-control" placeholder="00:00"/>

										<label [ngClass]="{'dirtySettingsField': changesStack.eqtimer}" [pTooltip]="getStackHTML('eqtimer')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">Window Duration</label>
										<select check-permission="Batt_EQ_sched_CustomSettings" name="eqtimer" [(ngModel)]="battview.eqtimer" class="form-control">
											<option *ngFor="let eqtime of quarts_2_24" [value]="eqtime">{{eqtime}}</option>
										</select>

										<label [ngClass]="{'dirtySettingsField': changesStack.eqdaysmask}" [pTooltip]="getStackHTML('eqdaysmask')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">Window Days</label>
										<label class="col-md-12">
											<button class="btn btn-info" check-permission="Batt_EQ_sched_CustomSettings" (click)="deselectAllDays('eqdaysmask')">Deselect All</button>
										</label>
										<select multiple check-permission="Batt_EQ_sched_CustomSettings" name="eqdaysmask" [(ngModel)]="battview.eqdaysmask" class="form-control" size="7">
											<option *ngFor="let day of daysOfTheWeek" [ngValue]="day.id">{{day.text}}</option>
										</select>

										<div *ngIf="battview.firmwareversion >= 2.1">
											<label [ngClass]="{'dirtySettingsField': changesStack.blockedeqdays}" [pTooltip]="getStackHTML('blockedeqdays')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">EQ Frequency</label>
											<div class='input-group'>
												<select check-permission="Batt_EQ_sched_CustomSettings" name="blockedeqdays" [(ngModel)]="battview.blockedeqdays" class="form-control">
													<option *ngFor="let day of blockedDaysOpts" [ngValue]="day.id">{{day.name}}</option>
												</select>
												<span class="input-group-addon"><span>Days</span></span>
											</div>
										</div>
									</fieldset>
								</div>

								<div check-permission="Batt_FI_sched_Settings" class="col-md-4 col-md-offset-2" *ngIf="battview.fischedulingmode">
									<fieldset>
										<legend>Finish Cycle Settings</legend>

										<label [ngClass]="{'dirtySettingsField': changesStack.fistartwindow}" [pTooltip]="getStackHTML('fistartwindow')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">Window Start Time</label>
										<input type='text' check-permission="Batt_FI_sched_CustomSettings" name="fistartwindow" [(ngModel)]="battview.fistartwindow" class="form-control" placeholder="00:00"/>

										<label [ngClass]="{'dirtySettingsField': changesStack.fitimer}" [pTooltip]="getStackHTML('fitimer')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">Window Duration</label>
										<select check-permission="Batt_FI_sched_CustomSettings" name="fitimer" [(ngModel)]="battview.fitimer" class="form-control">
											<option *ngFor="let finishtime of quarts_2_24" [value]="finishtime">{{finishtime}}</option>
										</select>

										<label [ngClass]="{'dirtySettingsField': changesStack.fidaysmask}" [pTooltip]="getStackHTML('fidaysmask')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">Window Days</label>
										<label class="col-md-12">
											<button class="btn btn-info" check-permission="Batt_FI_sched_CustomSettings" (click)="deselectAllDays('fidaysmask')">Deselect All</button>
										</label>
										<select multiple check-permission="Batt_FI_sched_CustomSettings" name="fidaysmask" [(ngModel)]="battview.fidaysmask" class="form-control" size="7">
											<option *ngFor="let day of daysOfTheWeek" [ngValue]="day.id">{{day.text}}</option>
										</select>

										<div *ngIf="battview.firmwareversion >= 2.1">
											<label [ngClass]="{'dirtySettingsField': changesStack.blockedfidays}" [pTooltip]="getStackHTML('blockedfidays')" [escape]="false" tooltipStyleClass="device-changes-log" tooltipPosition="right">FI Frequency</label>
											<div class='input-group'>
												<select check-permission="Batt_FI_sched_CustomSettings" name="blockedfidays" [(ngModel)]="battview.blockedfidays" class="form-control">
													<option *ngFor="let day of blockedDaysOpts" [ngValue]="day.id">{{day.name}}</option>
												</select>
												<span class="input-group-addon"><span>Days</span></span>
											</div>
										</div>
									</fieldset>
								</div>
							</div>
							<br/>
							<table class="cellpadding-10 col-xs-5 l">
								<tr>
									<td class="col-md-6" check-permission="SAVE-BATTVIEW-FI-EQ-SCHEDULING"><span class="save-btn" (click)="checkChanges('FIEQscheduling')">Save</span></td>
									<td><span class="back-btn" (click)="setTab('BATTVIEW-BATTERY-INFO'); resetForms()">Back</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<!-- BATTView Cellular Section -->
	<div check-permission="BATTVIEW-CELLULAR" *ngIf="isSet('BATTVIEW-CELLULAR')">
		<div class="panel panel-default">
			<div class="panel-body">
				<form name="battviewCellular">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-5">
								<tr check-permission="Batt_CellularActViewConnectFreq">
									<td class="col-md-6">Cellular ActView Connect Frequency</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.cellularactviewconnectfreq}" [pTooltip]="getStackHTML('cellularactviewconnectfreq')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_CellularActViewConnectFreq" type="text" class="form-control" [(ngModel)]="battview.cellularactviewconnectfreq" name="cellularactviewconnectfreq" maxlength="5" [disabled]="!battview.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Batt_CellularType">
									<td class="col-md-6">Cellular Type</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.cellulartype}" [pTooltip]="getStackHTML('cellulartype')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Batt_CellularTypet" class="form-control" [(ngModel)]="battview.data.cellulartype" name="cellulartype" disabled>
											<option [value]="0">Cellular</option>
											<option [value]="1">CBRS</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_ModemModel">
									<td class="col-md-6">Modem Model</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.modemmodel}" [pTooltip]="getStackHTML('modemmodel')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_ModemModel" type="text" class="form-control" [(ngModel)]="battview.data.modemmodel" name="modemmodel" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_ModemFWVer">
									<td class="col-md-6">Modem FW Version</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.modemfwversion}" [pTooltip]="getStackHTML('modemfwversion')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_ModemFWVer" type="text" class="form-control" [(ngModel)]="battview.data.modemfwversion" name="modemfwversion" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_ModemImei">
									<td class="col-md-6">Modem IMEI</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.modemimei}" [pTooltip]="getStackHTML('modemimei')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_ModemImei" type="text" class="form-control" [(ngModel)]="battview.data.modemimei" name="modemimei" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_ModemVendor">
									<td class="col-md-6">Modem Vendor</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.modemvendor}" [pTooltip]="getStackHTML('modemvendor')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_ModemVendor" type="text" class="form-control" [(ngModel)]="battview.data.modemvendor" name="modemvendor" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_ModemType">
									<td class="col-md-6">Modem Type</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.modemtype}" [pTooltip]="getStackHTML('modemtype')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Batt_ModemType" class="form-control" [(ngModel)]="battview.data.modemtype" name="modemtype" disabled>
											<option [value]="0">Dongle</option>
											<option [value]="1">Chip</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_ConnectedBand">
									<td class="col-md-6">Connected Band</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.connectedband}" [pTooltip]="getStackHTML('connectedband')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_ConnectedBand" type="text" class="form-control" [(ngModel)]="battview.data.connectedband" name="connectedband" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_NetworkOperator">
									<td class="col-md-6">Network Operator</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.networkoperator}" [pTooltip]="getStackHTML('networkoperator')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_NetworkOperator" type="text" class="form-control" [(ngModel)]="battview.data.networkoperator" name="networkoperator" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_RSSI">
									<td class="col-md-6">RSSI</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.rssi}" [pTooltip]="getStackHTML('rssi')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_RSSI" type="text" class="form-control" [(ngModel)]="battview.data.rssi" name="rssi" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_Sinr">
									<td class="col-md-6">SINR</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.sinr}" [pTooltip]="getStackHTML('sinr')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_Sinr" type="text" class="form-control" [(ngModel)]="battview.data.sinr" name="sinr" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_RadioAccessType">
									<td class="col-md-6">Radio Access Type</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.radioaccesstype}" [pTooltip]="getStackHTML('radioaccesstype')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Batt_RadioAccessType" class="form-control" [(ngModel)]="battview.data.radioaccesstype" name="radioaccesstype" disabled>
											<option [value]="0">CAT-M</option>
											<option [value]="1">NB-IoT</option>
											<option [value]="2">LTE(4G)</option>
											<option [value]="3">NR-5G</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_SimEid">
									<td class="col-md-6">Sim EID</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.simeid}" [pTooltip]="getStackHTML('simeid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_SimEid" type="text" class="form-control" [(ngModel)]="battview.data.simeid" name="simeid" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_SimIccid">
									<td class="col-md-6">Sim ICCID</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.simiccid}" [pTooltip]="getStackHTML('simiccid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_SimIccid" type="text" class="form-control" [(ngModel)]="battview.data.simiccid" name="simiccid" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_SimImsi">
									<td class="col-md-6">SIM IMSI</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.simimsi}" [pTooltip]="getStackHTML('simimsi')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_SimImsi" type="text" class="form-control" [(ngModel)]="battview.data.simimsi" name="simimsi" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_Sim_Status">
									<td class="col-md-6">Sim Status</td>
									<td [pTooltip]="getStackHTML('sim_status')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Batt_Sim_Status" class="form-control" [(ngModel)]="battview.data.sim_status" name="sim_status" disabled>
											<option [value]="0">Unknown</option>
											<option [value]="1">Ready</option>
											<option [value]="2">Locked</option>
											<option [value]="3">Not Detected</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_LenApnInUse">
									<td class="col-md-6">Length of APN</td>
									<td [pTooltip]="getStackHTML('len_apn_in_use')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_LenApnInUse" type="text" class="form-control" [(ngModel)]="battview.data.len_apn_in_use" name="len_apn_in_use" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_Apn_In_Use">
									<td class="col-md-6">APN in use</td>
									<td [pTooltip]="getStackHTML('apn_in_use')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_Apn_In_Use" type="text" class="form-control" [(ngModel)]="battview.data.apn_in_use" name="apn_in_use" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_Len_Apn_Configured">
									<td class="col-md-6">Length of APN Configured</td>
									<td [pTooltip]="getStackHTML('len_apn_configured')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_Len_Apn_Configured" type="text" class="form-control" [(ngModel)]="battview.data.len_apn_configured" name="len_apn_configured" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_ApnConfigured">
									<td class="col-md-6">APN Configured</td>
									<td [pTooltip]="getStackHTML('apn_configured')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Batt_ApnConfigured" type="text" class="form-control" [(ngModel)]="battview.data.apn_configured" name="apn_configured" readonly/>
									</td>
								</tr>
								<tr check-permission="Batt_RegistrationStatus">
									<td class="col-md-6">Registration Status</td>
									<td [pTooltip]="getStackHTML('registration_status')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Batt_RegistrationStatus" class="form-control" [(ngModel)]="battview.data.registration_status" name="registration_status" disabled>
											<option [value]="0">Not Registered/Not Searching</option>
											<option [value]="1">Registered</option>
											<option [value]="2">Searching</option>
											<option [value]="3">Denied</option>
											<option [value]="4">Unknown</option>
											<option [value]="5">Roaming</option>
											<option [value]="8">Emergency Services</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Batt_RFStatus">
									<td class="col-md-6">RF Status</td>
									<td [pTooltip]="getStackHTML('rf_status')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Batt_RFStatus" class="form-control" [(ngModel)]="battview.data.rf_status" name="rf_status" disabled>
											<option [value]="0">Unknown</option>
											<option [value]="1">Detected</option>
										</select>
									</td>
								</tr>
								<tr>
									<td check-permission="SAVE-BATTVIEW-CELLULAR"><span class="save-btn" (click)="checkChanges('battviewCellular')">{{'g.save'| translate}}</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms();">{{'g.back'| translate}}</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

</div>
